// src/data/eventPhotos.js

// 이미지는 public/image/event 폴더에 그대로 파일명 맞춰서 넣는다고 가정
export const BASE_PATH = '/image/event'

export const PHOTOS = [
    { file: '1 (1).JPG', caption: '이 날이 시작이었단 걸, 우리는 아직 모른 척하던 첫 장면.' },
    { file: '1 (2).JPG', caption: '어색함과 설렘이 섞여서, 괜히 웃음이 많았던 하루.' },
    { file: '1 (3).JPG', caption: '너만 자꾸 눈에 들어오기 시작한 때.' },
    { file: '1 (4).JPG', caption: '같이 걷고 있던 순간은 꼭 영화 한 장면 같았던 날.' },
    { file: '1 (5).JPG', caption: '눈이 멀어버릴 정도로 애정이 많아진 밤.' },
    { file: '1 (6).JPG', caption: '아무 계획도 없었는데, 네가 있어서 최고의 크리스마스였던 날.' },
    { file: '1 (7).JPG', caption: '이때부터 못난이였던 너.' },
    { file: '1 (8).JPG', caption: '네가 옆에 있다는 사실만으로 충분했던 순간.' },
    { file: '1 (9).JPG', caption: '나만의 열쇠로 만들어버린 사진.' },
    { file: '1 (10).JPG', caption: '사진 속 거리보다, 마음은 이미 훨씬 더 가까워져 있던 시기.' },
    { file: '1 (11).JPG', caption: '둘이 있다는 이유만으로 아끼게 되는 사진.' },
    { file: '1 (12).JPG', caption: '살아가며 문제가 생겨도 같이 해결해 나간 하루.' },
    { file: '1 (13).JPG', caption: '더운 날씨보다 더 뜨거웠던 너.' },
    { file: '1 (14).JPG', caption: '찰나의 계절을 함께 지나가면서, 우리만의 온도를 배워가던 시간.' },
    { file: '1 (15).JPG', caption: '카메라를 의식하지 않아도, 같은 곳을 바라만 보던 날.' },
    { file: '1 (16).JPG', caption: '특별한 이벤트는 없어도, 함께여서 유난히 따뜻했던 평범한 하루.' },
    { file: '1 (17).JPG', caption: '멀리 가지 않아도 좋다는 걸, 이때부터 알게 됐던 것 같다.' },
    { file: '1 (18).JPG', caption: '또렷하게 기억에 남아 있는 장면.' },
    { file: '1 (19).JPG', caption: '불꽃축제의 밤.' },
    { file: '1 (20).JPG', caption: '동그란 뽀둥이가 물에 젖은 날.' },
    { file: '1 (21).JPG', caption: '생각보다 무서웠던 흔들다리.' },
    { file: '1 (22).JPG', caption: '하나씩 쌓여 추억이 되어가던 시간.' },
    { file: '1 (23).JPG', caption: '서로의 하루가 연결되던 순간들.' },
    { file: '1 (24).JPG', caption: '조금만 더 천천히 갔으면 좋겠던 밤.' },
    { file: '1 (25).JPG', caption: '전 남친.' },
    { file: '1 (26).JPG', caption: '조뽀둥 미용실력.' },
    { file: '1 (27).JPG', caption: '이 사진만 봐도 기분 좋은 장면.' },
    { file: '1 (28).JPG', caption: '이러지 말오.' },
    { file: '1 (29).JPG', caption: '평생 살자 우리 애기.' },
    { file: '1 (30).JPG', caption: '세상에 둘뿐인 느낌이었다.' },
    { file: '1 (31).JPG', caption: '이쯤 되니까, 우리 얘기가 단순한 추억이 아니라 운명이란 걸 확실히 알게 된 때.' },
    { file: '1 (32).JPG', caption: '사진에는 다 담기지 않는 온기를, 마음으로 꾹꾹 눌러 담던 순간.' },
    { file: '1 (33).JPG', caption: '같은 포즈를 하며 점점 닮아가던 우리.' },
    { file: '1 (34).JPG', caption: '분명 다시 꺼내보게 될 거라 느껴지는 사진.' },
    { file: '1 (35).JPG', caption: '이날의 우리는 따뜻했다.' },
    { file: '1 (36).jpg', caption: '만들어온 계절들 위에, 또 하나의 계절이 조용히 포개지던 어느 날.' },
    { file: '1 (37).jpg', caption: '조명으로 개명한 날.' },
    { file: '1 (38).jpg', caption: '남들이 느리다 해도 우리만의 속도로 한 걸음씩 나아가는 중.' },
    { file: '1 (39).jpg', caption: '돌아보면 가장 좋았던 날들 한가운데에는 항상 네가 있었다.' },
    { file: '1 (40).jpg', caption: '이제는 말하지 않아도 서로 알 수 있는 것들이 많아진 시간.' },
    { file: '1 (41).jpg', caption: '그리고 오늘, 우리 이야기는 여전히 예쁘게 현재 진행 중이다.' },
]
